<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="home-on-the-plane">
<h1>Home on the Plane</h1>
<p style="text-indent:0px;">As I peer down upon a valley of clouds,</p>
<p style="text-indent:0px;">Like a blanket of freshly fallen snow,</p>
<p style="text-indent:0px;">I catch a glimpse of what surrounds,</p>
<p style="text-indent:0px;">A horizon that seems to, for infinity, grow.</p><br/>
<p style="text-indent:0px;">It is sunset now here above,</p>
<p style="text-indent:0px;">The colours they twist orange and yellow.</p>
<p style="text-indent:0px;">I feel a peaceful, surreal love,</p>
<p style="text-indent:0px;">For something that I do not know.</p><br/>
<p style="text-indent:0px;">A space has cleared as I look down,</p>
<p style="text-indent:0px;">A sketched mountain range is all I see.</p>
<p style="text-indent:0px;">In the distance is a forgotten town,</p>
<p style="text-indent:0px;">An undiscovered river in a lost valley.</p><br/>
<p style="text-indent:0px;">Darkness creeps in when I look up,</p>
<p style="text-indent:0px;">I can barely make out a changing scene,</p>
<p style="text-indent:0px;">Wondering where I sit on a map,</p>
<p style="text-indent:0px;">Outside a chilled jet stream.</p><br/>
<p style="text-indent:0px;">A passage of time passes without distraction,</p>
<p style="text-indent:0px;">Then in the distance I see city lights.</p>
<p style="text-indent:0px;">An amazing man-made attraction,</p>
<p style="text-indent:0px;">Eyes too busy to take in all the sights.</p><br/>
<p style="text-indent:0px;">Captain’s order is that we are arriving,</p>
<p style="text-indent:0px;">The plane, it begins to descend,</p>
<p style="text-indent:0px;">Back to a place that is thriving,</p>
<p style="text-indent:0px;">A place where my happiness is just pretend.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?68f259a5